const defaultSearchImageList = {
  state: () => ({
    defaultSearchImageList: [] // 默认规格图
  }),
  mutations: {
    SetDefaultSearchImageList (state, data) {
      state.defaultSearchImageList = data
    }
  },
  actions: {
    SetDefaultSearchImageList({commit}, payload) {
      commit('SetDefaultSearchImageList',payload)
    },
  },
  getters: {
    defaultSearchImageList(state) {
      return state.defaultSearchImageList
    }
  }
}

export default defaultSearchImageList
